module.exports = __webpack_public_path__ + "img/logo-transparent.83bbe383.png";